import { render, staticRenderFns } from "./AppButtonEditCustomer.vue?vue&type=template&id=04c9d21f&scoped=true&"
import script from "./AppButtonEditCustomer.vue?vue&type=script&lang=ts&"
export * from "./AppButtonEditCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c9d21f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
